import React, { useState } from "react"
import FormManyCategory from "../../form/category/FormManyCategory"
import FormChoiceCatalog from "../../form/catalog/FormChoiceCatalog"

const ManyBoxCategory = props => {
    const itemClass = "manyForm"
    const defaultCatalog = JSON.parse(localStorage.getItem("catalog"))
    const { list, handleClose } = props
    const [ globalError, setGlobalError ] = useState(null)
    const [ catalogId, setCatalogId ] = useState(Object.keys(defaultCatalog).length > 0 ? defaultCatalog.id : null)

    return (
        <div className="overlayer">
            <div className="wrapOverbox">
                <div className={ "overbox " + itemClass }>
                    {
                        globalError !== null
                        && <p className="error">{ globalError }</p>
                    }
                    {
                        catalogId === null
                            ? <FormChoiceCatalog setCatalogId={ setCatalogId } setGlobalError={ setGlobalError } handleClose={ handleClose } />
                            : <FormManyCategory list={ list } catalogId={ catalogId } handleClose={ handleClose } />
                    }
                </div>
            </div>
        </div>
    )
}

export default ManyBoxCategory;
